import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SpreadsheetPreviewSection from './components/SpreadsheetPreviewSection';
import TrendingSection from './components/TrendingSection';
import ArticlePreview from './components/ArticlePreview';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_SITE_URL) || 'https://pandabuy.forum';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'PandaBuy Spreadsheet Hub',
  url: siteUrl,
  description: 'The #1 PandaBuy Spreadsheet Hub for curated finds, deals, and verified lists. Discover updated pandabuyspreadsheet collections for sneakers, streetwear, luxury-inspired items, and budget finds — all in one place.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: siteUrl + '/?search={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'PandaBuy Spreadsheet Hub',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <SpreadsheetPreviewSection />
      <TrendingSection />
      <ArticlePreview />
      <AboutSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </main>
  );
}